import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FormMultiSelect from "../form/FormMultiSelect";
import TmwApi from "../../containers/Ticket/TmwApi";

class TmwBillerSelect extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			billers : [],
		};
	}
	componentDidMount() {
		const { getBillerList } = this.props;

		getBillerList({
			callback : (err, r) => {
				if (err) {
					return console.error(err);
				}
				this.setState({ billers : r.billers });
			}
		});
	}

	render () {
		const { value } = this.props;
		const { billers = []} = this.state;

		let options = billers.map((biller) => {
			const { lastUpdatedBy} = biller;
			return {
				value: lastUpdatedBy,
				display: lastUpdatedBy,
			};
		});
		options = _.sortBy(options, 'display');

		return (
			<FormMultiSelect
				{...this.props}
				// so an empty thing doesn't flicker in
				value={_.isEmpty(billers) ? [] : value}
				options={options}
			/>
		);
	}
}

TmwBillerSelect.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.array,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	getBillerList : PropTypes.func.isRequired,

	classes : PropTypes.object,
	helpText : PropTypes.string,
};

TmwBillerSelect.defaultProps =  {
	label : 'Bill To Customer',
	billers : [],
};

export default TmwApi(TmwBillerSelect);
